import { render, staticRenderFns } from "./DIAGDesviosOperacionais.vue?vue&type=template&id=034136cc&"
import script from "./DIAGDesviosOperacionais.vue?vue&type=script&lang=js&"
export * from "./DIAGDesviosOperacionais.vue?vue&type=script&lang=js&"
import style0 from "./DIAGDesviosOperacionais.vue?vue&type=style&index=0&id=034136cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports